export const notificationTypeEnum = {
  UPDATE_PROFILE: 'update_profile', // CHANGE_USERNAME_OR_PIN
  EMAIL_VERIFICATION: 'email_verification', // EMAIL_VERIFICATION
  ACHIEVEMENT: 'achievement', // ACHIEVEMENT
  LEVEL_UP: 'level_up',  // LEVELED_UP
  BONUS_BUNDLE_DISCOUNT: 'bonus_bundle_discount', // BUNDLE_DISCOUNT
  BONUS_GAME_POINTS: 'bonus_game_points', // BONUS_POINTS_PHASE
  BONUS_DAILY_VISIT: 'bonus_daily_visit', // BONUS_PHASES_DAILY
  GAME_PUZZLE: 'bonus_game_puzzle', // PENDING_PUZZLE_GAME || PENDING_SPINNING_WHEEL_GAME
  GAME_LANTERNS: 'bonus_game_lanterns', // PENDING_LIGHT_THE_LANTERNS_GAME || PENDING_SPINNING_WHEEL_GAME
  REFERRAL_REGISTRATION: 'referral_registration', // BONUS_REFERRAL_REGISTRATION || INVITE_REGISTRATION
  BALANCE_ZERO_GAMES: 'balance_zero_games', //  // ZERO_BALANCE || NOT_ENOUGH_BALANCE
};

export const notificationDescriptionTextTypeEnum = {
  TRANSLATION_KEY: 'translation_key',
  STYLED_TRANSLATION_KEY: 'styled_translation_key',
  DYNAMIC_VALUE: 'dynamic_value',
};
